import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var BadgeStyle = function BadgeStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  return css([".c7n-badge-status-default{background-color:#d50000;}.c7n-badge-status-processing.c7n-badge-status-processing{background-color:", ";&::after{border-color:", ";}}"], primary, primary);
};
export default BadgeStyle;